module.exports = __webpack_public_path__ + "assets/img/17_1040_big.366e678f.jpg";